export default "__VITE_ASSET__ItZ4tJs8__"